import _slicedToArray from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import InputNumber from '../../input-number';

var ColorSteppers = function ColorSteppers(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      value = _ref.value,
      _onChange = _ref.onChange,
      className = _ref.className,
      formatter = _ref.formatter;
  var colorSteppersPrefixCls = "".concat(prefixCls, "-steppers");

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      stepValue = _useState2[0],
      setStepValue = _useState2[1]; // Update step value


  useEffect(function () {
    if (!Number.isNaN(value)) {
      setStepValue(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(InputNumber, {
    className: classNames(colorSteppersPrefixCls, className),
    min: min,
    max: max,
    value: stepValue,
    formatter: formatter,
    size: "small",
    onChange: function onChange(step) {
      if (!value) {
        setStepValue(step || 0);
      }

      _onChange === null || _onChange === void 0 ? void 0 : _onChange(step);
    }
  });
};

export default ColorSteppers;